



































































































































































import { MemberManagementMemberHistoryService as memberHistoryApi } from "@/common/api";
import { ORDER_TYPE } from "@/common/constant";
import QErrors from "@/common/qErrors.vue";
import { formatImageUrl } from "@/common/utils";
import PostalCode from "@/components/common/postalCode.vue";
import { DELIVERY_TYPES } from "@/model/order";
import { Component, Vue } from "vue-property-decorator";
// eslint-disable-next-line @typescript-eslint/no-var-requires
const noImage = require("@/assets/images/muuq-base/noimage.svg");

@Component({
  name: "MemberOrderInfoComponent",
  components: {
    QErrors,
    PostalCode,
  },
})
export default class MemberOrderInfoComponent extends Vue {
  public isShow = false;
  public order: any = {};

  public get ORDER_TYPE() {
    return ORDER_TYPE;
  }

  public show(orderId) {
    this.getOrderInfo(orderId);
    this.isShow = true;
  }

  public async getOrderInfo(id) {
    const result = await memberHistoryApi.adminMemberHistoryView({
      id,
    });

    this.order = result.data.order;
  }

  public closePopup() {
    this.isShow = false;
    this.order = {};
  }

  public formatUrl(fileName) {
    return fileName ? formatImageUrl(fileName, "88x88", "contain") : noImage;
  }

  public getUrlOrder(orderCode) {
    if (!orderCode) { return "#"; }
    if (orderCode.charAt(0) === "L") {
      return "/bid?code=" + orderCode;
    } else if (orderCode.charAt(0) === "K") {
      return "/carpsale-history?code=" + orderCode;
    } else {
      return "/store-history?code=" + orderCode;
    }
  }

  public getAgeName(livecarpItem) {
    return livecarpItem.age_id ? livecarpItem.age.name : "";
  }

  public getStoreItemBasicInfo(orderDetail) {
    const msessage = orderDetail.code ? orderDetail.code : "---";
    const optionName = orderDetail.option_names ? orderDetail.option_names : "";
    return "[" + msessage + "]" + orderDetail.name + " " + optionName;
  }
  public get isDelivery() {
    return this.order.delivery_type === DELIVERY_TYPES.DELIVERY;
  }
}
